<template>
  <section class="container" :class="!isMeeting ? 'boxWithBorder' : ''">
    <!-- Meeting Info Bar bar -->
    <div v-if="isMeeting" class="box">
      <div v-if="route() != '/meetings/flights-results'">
        <MeetingDatesInfoForUser />
        <hr />
      </div>

      <p class="is-size-5">
        Will you provide your own transportation to and from this meeting?
      </p>
      <!-- <b-button>
        Opt out of flight search steps
      </b-button> -->
      <p class="is-size-6 mb-3">
        If you do not need air travel booked for this meeting, please click
        below to skip the flight search steps.
      </p>
      <b-button @click="optOutFlight" type="is-primary">
        No Air Travel Required
      </b-button>
    </div>

    <SmallItinerarySidebar
      v-if="bookTrip.currentlyBooking"
      :sol="solutionAll"
      :key="
        solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key
      "
      class="bookingDropdown mr-5"
    />

    <!-- Form Title -->
    <div
      v-if="!isMeeting"
      class="is-flex is-justify-content-center is-align-content-center mb-3"
    >
      <b-icon icon="airplane" size="" type="is-primary"> </b-icon>
      <h2 class="gant-text is-bold ml-1">Flights</h2>
    </div>

    <!-- TODO fix -->
    <EditSearchLink
      v-if="showEditSearchLink('flight')"
      :label="toggleSearchLabel('flight')"
      @iconClicked="toggleSearchForm('flight')"
    />

    <div
      class="flightForm"
      :class="bookTrip.currentlyBooking ? 'pt-2' : ''"
      v-if="!this.bookTravel.formsCollapsed.flight"
    >
      <div :class="isMeeting ? 'box' : ''">
        <!-- Action bar -->
        <div class="is-flex is-justify-content-center flexContainer">
          <div class="flexContainerItem">
            <div class="is-flex is-justify-content-center">
              <TripTypeSelectorDropdown
                v-if="!pathMixin_isMeeting"
                :startVal="tripVal"
                @switch="toggle1way"
                class="flexContainerItem"
              />
              <CabinClassSelectorDropdown
                @input="updateCabinClass"
                :selectedValue="cabinClass"
                :cabinOptions="cabinOptions"
                class="ml-1 flexContainerItem"
              />

            </div>
          </div>
          <UserAirNotifications
            class="ml-1 flexContainerItem is-hidden-touch"
            custom-style="font-size: 12px;"
          />
        </div>
        <!-- END OF Action bar -->

        <b-message type="is-warning" v-if="isMeeting" class="mt-3">
          <span v-html="labelForMeeting('depart')"></span> <br />
          <span v-html="labelForMeeting('return')"></span>
        </b-message>

        <!--  One-Way & Round Trip -->
        <div
          v-show="tripVal === TRIP_ONE_WAY || tripVal === TRIP_ROUNDTRIP"
          class="mt-3"
        >
          <div class="is-flex is-justify-content-space-between flexContainer">
            <div class="is-flex-grow-1 flexContainerItem">
              <LocationSearch
                data-test="depart_airport"
                icon="airplane-takeoff"
                :key="locationKey"
                :value="loc1"
                @locUpdate="setValue1"
                :offerHomeAirport="true"
                :autofocus="true"
                :placeholder="'From (e.g. LAX, BOS)'"
                data-test-attr="from-destination"
              />
            </div>
            <div
              class="is-flex-grow-0 flexContainerItem swapFlightsContainer"
              v-if="!pathMixin_isMeeting"
            >
              <a class="image is-48x48 swapFlightsButton is-hidden-mobile">
                <img
                  :class="swapButton"
                  class="fade"
                  @click="switchLoc"
                  src="/images/gantFlipButton.png"
                  alt="Swap Airports"
                />
              </a>
            </div>
            <div
              class="is-flex-grow-1 flexContainerItem departLocationSearch"
              v-if="!pathMixin_isMeeting"
            >
              <LocationSearch
                data-test="arrive_airport"
                icon="airplane-landing"
                :key="locationKey"
                :value="loc2"
                @locUpdate="setValue2"
                ref="loc2"
                :offerHomeAirport="true"
                :placeholder="'To (e.g. LAX, BOS)'"
                data-test-attr="to-destination"
              />
            </div>
            <div
              class="is-flex-grow-1 ml-1 flexContainerItem departLocationSearch"
              v-else
            >
              <LocationSearchMeetings
                data-test="arrive_airport_meetings"
                icon="airplane-landing"
                @locUpdate="setMeetingsDestination"
                :options="meetingAirports"
                :preferred="prefAirport"
              />
            </div>

            <div class="is-flex-grow-2 flexContainerItem">
              <div class="is-flex flexContainer flexContainerRow">
                <div class="is-flex-grow-1 mr-1 flexContainerItem">
                  <FlightDateTimeSelector
                    data-test="departDate"
                    ref="departDate"
                    :dateIndex="0"
                    v-model="startDate"
                    :placeholder="'Depart'"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    :focusedDate="focusedDate"
                    @setDate="toggleReturn"
                    @showAdvanced="showAdvanced"
                    @meetingInput="setMeetingsDepartDate"
                    @setDateRange="setDateRange"
                  />
                </div>
                <div
                  class="is-flex-grow-1 flexContainerItem"
                  v-if="tripVal === TRIP_ROUNDTRIP"
                >
                  <FlightDateTimeSelector
                    data-test="returnDate"
                    ref="returnDate"
                    :dateIndex="1"
                    v-model="endDate"
                    :placeholder="'Return'"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    :focusedDate="focusedDate"
                    @showAdvanced="showAdvanced"
                    @meetingInput="setMeetingsReturnDate"
                    @setDateRange="setDateRange"
                  />
                </div>
              </div>
            </div>

            <div
              class="is-flex-grow-1 flexContainerItem searchButton is-hidden-mobile is-hidden-touch"
            >
              <b-button
                data-test="desktop_submit_button"
                @click="checkInputs"
                class="button is-primary ubuntu"
                expanded
              >
                Search Flights
              </b-button>
            </div>
          </div>

          <b-collapse
            :open="advancedOptionOpen"
            @open="advancedOptionOpen = true"
            @close="advancedOptionOpen = false"
            aria-id="contentIdForA11y1"
            data-test="advance-search-opener"
          >
        
            <AdvancedSearchOptionsLink data-test="advanced-search-options-link" slot="trigger" />
            
            <div data-test="advance-search-container" class="notification px-3">
              <button
                class="delete"
                @click="advancedOptionOpen = false"
              ></button>
              <div class="content">
                <h3>Time Preference</h3>
                <div class="columns">
                  <b-field class="column ">
                    <b-radio-button
                      size="is-small"
                      type="is-primary is-light is-outlined"
                      v-for="option in times"
                      v-model="startDate.advanced.tod"
                      :key="option.format"
                      :name="option.format"
                      :native-value="option.format"
                      :disabled="showAdvancedSearchD == 0"
                      :data-test="'start-choice-'+option.format.toLowerCase()"
                    >
                      {{ option.format }}
                    </b-radio-button>
                  </b-field>

                  <b-field class="column" v-if="tripVal === TRIP_ROUNDTRIP">
                    <b-radio-button
                      size="is-small"
                      type="is-primary is-light is-outlined"
                      v-for="option in times"
                      v-model="endDate.advanced.tod"
                      :key="option.format"
                      :native-value="option.format"
                      :disabled="showAdvancedSearchR == 0"
                      :data-test="'depart-choice-'+option.format.toLowerCase()"
                    >
                      <span style=""> {{ option.format }} </span>
                    </b-radio-button>
                  </b-field>
                </div>
              </div>
              <div class="columns" >
                <div class="column">
                  <div data-test="outbound-container" class="content">
                    <h4 v-if="startDate.advanced.tod == 'Custom'">
                      Outbound Flight
                    </h4>
                    <div
                      v-if="startDate.advanced.tod == 'Custom'"
                      class="columns"
                    >
                      <div class="column" data-test="outbound-timepicker-container">
                        <b-field>
                          <b-timepicker
                            data-test="outbound-timepicker"
                            ref="startClock"
                            rounded
                            icon="clock"
                            is-small
                            :incrementMinutes="minutesGranularity"
                            :hour-format="hourFormat"
                            v-model="startDate.advanced.time"
                          >
                          </b-timepicker>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field>
                          <b-radio-button
                            data-test="outbound-takeoff"
                            v-model="outboundTakeoff"
                            native-value="takeoff"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-takeoff"></b-icon>
                            Takeoff
                          </b-radio-button>
                          <b-radio-button
                            data-test="outbound-arrival"
                            v-model="outboundTakeoff"
                            native-value="arrival"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-landing"></b-icon>
                            Arrival
                          </b-radio-button>
                        </b-field>
                      </div>
                    </div>

                    <b-field
                      v-if="startDate.advanced.tod == 'Custom'"
                      :label="plusorMinusHours1"
                    >
                      <b-numberinput
                        data-test="outbound-plusminus"
                        v-model="startDate.advanced.hours"
                        min="1"
                        max="10"
                        :step="1"
                        controls-position="compact"
                      >
                      </b-numberinput>
                    </b-field>
                  </div>
                </div>
                <div class="column">
                  <div
                    class="content"
                    data-test="return-container"
                    v-show="
                      tripVal == TRIP_ROUNDTRIP &&
                        endDate.advanced.tod == 'Custom'
                    "
                  >
                    <h4>Return Flight</h4>
                    <div data-test="return-timepicker-container" class="columns">
                      <div class="column">
                        <b-field>
                          <b-timepicker
                            data-test="return-timepicker"
                            ref="endClock"
                            rounded
                            icon="clock"
                            is-small
                            :incrementMinutes="minutesGranularity"
                            :hour-format="hourFormat"
                            v-model="endDate.advanced.time"
                          >
                          </b-timepicker>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field>
                          <b-radio-button
                            data-test="return-takeoff"
                            v-model="returnTakeoff"
                            native-value="takeoff"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-takeoff"></b-icon>
                            Takeoff
                          </b-radio-button>
                          <b-radio-button
                            data-test="return-arrival"
                            v-model="returnTakeoff"
                            native-value="arrival"
                            type="is-primary is-light is-outlined"
                          >
                            <b-icon icon="airplane-landing"></b-icon>
                            Arrival
                          </b-radio-button>
                        </b-field>
                      </div>
                    </div>

                    <b-field :label="plusorMinusHours2">
                      <b-numberinput
                        data-test="return-plusminus"
                        v-model="endDate.advanced.hours"
                        min="1"
                        max="10"
                        :step="1"
                        controls-position="compact"
                      >
                      </b-numberinput>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>

        <!-- Multi-City -->
        <div v-show="tripVal === TRIP_MULTI_CITY" class="mt-3">
          <MultiCityRow
            v-for="(child, index) in multiCityRows"
            :index="index"
            v-model="multiCityRows[index]"
            :notAlone="multiCityRows.length > 1"
            :key="index"
            ref="multiRows"
            :minDate="defaultDateRow(index)"
            :focusedDate="defaultDateRow(index)"
            @update="updateRow(index, $event)"
            @nextLeg="focusNextLeg"
            @remove="removeRow"
            class="pr-5"
            data-test="multiple-city-flight-row"
          />

          <div class="columns pr-5">
            <div class="column is-one-third">
              <a
                class="is-info is-size-7 has-text-grey-light"
                v-if="multiCityRows.length < 3"
                @click="addRow"
                data-test="another-flight"
              >
                + Add another Flight
              </a>
            </div>
            <div class="column is-hidden-mobile is-hidden-touch">
              <b-button
                data-test="desktop_submit_button_multiple_city"
                @click="checkInputs"
                class="button is-primary ubuntu is-pulled-right"
              >
                Search Flights
              </b-button>
            </div>
          </div>
        </div>

        <div
          class="is-flex-grow-1 flexContainerItem searchButton is-hidden-desktop"
        >
          <b-button
            data-test="mobile_submit_button"
            @click="checkInputs"
            class="button is-primary ubuntu"
            expanded
          >
            Search Flights
          </b-button>
        </div>
      </div>
    </div>

    <FlightResults v-if="showFlightResults" :formData="formData" />
  </section>
</template>

<script>
import moment from "moment";
import MultiCityRow from "./MultiCityRow.vue";
import FlightDateTimeSelector from "./FlightDateTimeSelector.vue";
import LocationSearch from "../../EDLocation/EDLocationSearch.vue";
import TripTypeSelectorDropdown from "./TripTypeSelectorDropdown";
import CabinClassSelectorDropdown from "./CabinClassSelectorDropdown";
//import GuestSelectorDropdown from "./GuestSelectorDropdown";
import AdvancedSearchOptionsLink from "../../UI/AdvancedSearchOptionsLink";
import UserAirNotifications from "../../User/UserAirNotifications";
import LocationSearchMeetings from "../../EDLocation/EDLocationSearchMeetings";
import TravellerModal from "../../Traveller/TravellerModal";
import bookingMixin from "@/mixins/bookingMixin";
import meetingsMixin from "@/mixins/meetingsMixin";
import EditSearchLink from "../EditSearchLink";
import { mapState } from "vuex";
import SmallItinerarySidebar from "../../Itinerary/SmallItinerarySidebar";
import MeetingDatesInfoForUser from "../../Meetings/MeetingDatesInfoForUser";
import FlightResults from "./FlightResults";

export default {
  name: "FlightForm",
  mixins: [bookingMixin, meetingsMixin],
  components: {
    AdvancedSearchOptionsLink,
    MultiCityRow,
    FlightDateTimeSelector,
    LocationSearch,
    TripTypeSelectorDropdown,
    CabinClassSelectorDropdown,
    UserAirNotifications,
    LocationSearchMeetings,
    EditSearchLink,
    SmallItinerarySidebar,
    MeetingDatesInfoForUser,
    FlightResults,
  },
  data() {
    let today = new Date();
    return {
      today: today,
      minutesGranularity: 15,
      hourFormat: "12",
      hours1: 2,
      hours2: 2,
      advancedOptionOpen: false,
      locationKey: 0,
      showFlightResults: false,
      meetingsDepartDate: null,
      meetingsReturnDate: null,
      meetingsDestination: null, // TODO test for possible removal ?
      showAdvancedSearchD: true,
      showAdvancedSearchR: true,
      showTimeSelectorDepart: true,
      showTimeSelectorReturn: true,
      formData: {},
      //FORM DATA
      tripVal: 1,
      cabinClass: "Y",
      loc1: { name: "", locType: "" },
      loc2: { name: "", locType: "" },
      startDate: {
        date: null,
        advanced: {
          time: null,
          isDeparture: true,
          tod: "Anytime",
          hours: 2,
        },
      },
      endDate: {
        date: null,
        advanced: {
          time: null,
          isDeparture: true,
          tod: "Anytime",
          hours: 2,
        },
      },
      multiCityRows: [],
      //END FORM DATA
    };
  },
  computed: {
    swapButton() {
      return this.$app.isMobileVersion()
        ? "mobile-swapButton"
        : "desktop-swapButton";
    },
    plusorMinusHours1() {
      return "+/-" + this.hours1 + " hours";
    },
    plusorMinusHours2() {
      return "+/-" + this.hours2 + " hours";
    },
    isPersonalTrip() {
      return (
        this.$store.getters["travellersAndTrips/getTravellers"].tripType ==
        "personal"
      );
    },
    focusedDate() {
      if (this.startDate.date) {
        return this.startDate.date;
      } else {
        return new Date();
      }
    },
    minDate() {
      if (this.pathMixin_isMeeting) {
        return this.minMeetingDepartDate;
      } else {
        return new Date(); //this.$date.getFirstTravelDate();
      }
    },
    numGuests: {
      get(){
        return this.$store.state.bookTravel.numGuests;
      },
      set(value){
        console.log('got it: ' + value)
        this.$store.commit('bookTravel/SET_NUM_GUESTS', value); 
      }
    },
    maxDate() {
      if (this.pathMixin_isMeeting) {
        return this.maxMeetingReturnDate;
      } else {
        return this.$date.getLastTravelDate().toDate();
      }
    },
    outboundTakeoff: {
      get() {
        return this.startDate.advanced.isDeparture ? "takeoff" : "arrival";
      },
      set(value) {
        if (value == "takeoff") {
          this.startDate.advanced.isDeparture = true;
        } else {
          this.startDate.advanced.isDeparture = false;
        }
      },
    },
    returnTakeoff: {
      get() {
        return this.endDate.advanced.isDeparture ? "takeoff" : "arrival";
      },
      set(value) {
        if (value == "takeoff") {
          this.endDate.advanced.isDeparture = true;
        } else {
          this.endDate.advanced.isDeparture = false;
        }
      },
    },
    cabinOptions() {
      if (this.isPersonalTrip) return null;

      let cabinOptions = null;

      // If we are in meeting mode then use the cabin options from the
      // travel policy associated to the traveler for this meeting.
      // Otherwise use the options for the traveler's regular travel policy
      if (this.pathMixin_isMeeting) {
        if (
          this.$store.state.meetings.meetingInfo.travelPolicy &&
          this.$store.state.meetings.meetingInfo.travelPolicy.cabinOptions
        ) {
          cabinOptions = this.$store.state.meetings.meetingInfo.travelPolicy
            .cabinOptions;
        }
      } else if (this.$globals.profile.travelPolicy) {
        cabinOptions = this.$globals.profile.travelPolicy.cabinOptions;
      }

      return cabinOptions;
    },
    errorMessages() {
      var messages = [];
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      if (
        this.tripVal === this.TRIP_ONE_WAY ||
        this.tripVal === this.TRIP_ROUNDTRIP
      ) {


        if (!Object.hasOwn(this.loc1, 'code')) {
          messages.push('Please enter a valid "from" airport');
        }

        if (!Object.hasOwn(this.loc2, 'code')) {
          messages.push('Please enter a valid "to" airport');
        }

        if (!this.startDate.date) {
          messages.push("Please select a valid departure date");
        }

        if (this.startDate.date < yesterday) {
          messages.push("Please select a valid departure date");
        }

        if (
          this.endDate.date < yesterday &&
          this.tripVal === this.TRIP_ROUNDTRIP
        ) {
          messages.push("Please select a valid return date");
        }

        if (
          this.tripVal === this.TRIP_ROUNDTRIP &&
          this.startDate.date > this.endDate.date
        ) {
          messages.push("Return date is after departure date");
        }
      } else {

        var previousDate;
        if (this.multiCityRows[0].depDate.date < yesterday) {
          messages.push("Please select a future departure date for flight 1");
        }
        for (var child = 0; child < this.multiCityRows.length; child++) {
          if (!this.multiCityRows[child].fromLoc.code) {
            messages.push('Invalid "from" airport in flight ' + (child + 1));
          }
          if (!this.multiCityRows[child].toLoc.code) {
            messages.push('Invalid "to" airport in flight ' + (child + 1));
          }
          if (
            !(child === 0) &&
            this.multiCityRows[child].depDate.date < previousDate
          ) {
            messages.push(
              "Flight " + (child + 1) + " date must be after Flight " + child
            );
          }
          previousDate = this.multiCityRows[child].depDate.date;
        }
      }
      return messages;
    },
  },
  methods: {
    // TODO check all methods that have dates or use moment() and see if those can be standardized
    checkInputs() {
      if (this.errorMessages.length > 0) {
        this.launchInputErrorDialog(this.errorMessages);
      } else {
        this.presearch();
      }
    },
    presearch() {
      if (this.$store.state.travellersAndTrips.travellers.set) {
        this.search();
      } else {
        this.cardModal();
      }
    },
    search() {
      // TODO test Meeting after Dates Cleanup finished
      // TODO test for possible removal ?
      if (this.pathMixin_isMeeting) {
        this.$store.commit(
          "meetings/ALTER_MEETING_AIRPORT_SELECTED",
          this.meetingsDestination
        );
      }
      //
      this.showFlightResults = true;
      this.advancedOptionOpen = false;

      this.formData = {
        tripVal: this.tripVal,
        cabinClass: this.cabinClass,
        loc1: this.loc1,
        loc2: this.loc2,
        minDate: this.minDate,
        startDate: this.startDate,
        endDate: this.endDate,
        multiCity: this.multiCityRows
      };
    },
    showAdvanced() {
      this.advancedOptionOpen = true;
    },
    switchLoc() {
      //this.$store.dispatch("bookTravel/switchLoc");
      let temp = this.loc1;
      this.loc1 = this.loc2;
      this.loc2 = temp;
      this.locationKey += 1;
    },
    setDateRange(range) {
      this.startDate.date = range[0];
      this.endDate.date = range[1];
    },
    setValue1(value) {
      if (this.$refs.loc2) {
        this.$refs.loc2.setUp();
      }
      this.loc1 = value;
    },
    setValue2(value) {
      this.loc2 = value;
      //toggle the depart DatePicker
      this.toggleDepart();
    },
    updateCabinClass(value) {
      this.cabinClass = value;
    },
    toggle1way(value) {
      this.tripVal = value;
    },
    setTravellers() {
      let travellers = {
        tripType: "business",
        bookFor: "user",
        others: [],
        set: true,
        business: true,
        self: true,
      };
      this.$store.commit("travellersAndTrips/EDIT_TRAVELLERS", travellers);
    },
    cardModal(closable = true) {
      var details = {
        parent: this,
        component: TravellerModal,
        props: {
          profile: this.$globals.profile,
          closable: closable,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
      };
      this.$buefy.modal.open(details);
    },
    route() {
      return this.$route.path;
    },
    // for Meetings
    setMeetingsDepartDate(val) {
      this.meetingsDepartDate = val;
      this.validateMeetingDates(val, "depart");
    },
    setMeetingsReturnDate(val) {
      this.meetingsReturnDate = val;
      this.validateMeetingDates(val, "return");
    },
    labelForMeeting(type) {
      let label = "";

      if (type == "depart") {
        //label += '<strong>Departure: </strong> ';
        if (this.meetingInfo.meeting.latestArrival.time !== null) {
          label += `<span class="is-size-7">ARRIVE by
                        <b>${this.$date.convertTime(
                          this.meetingInfo.meeting.latestArrival.time
                        )}</b>
                        on ${moment(
                          this.meetingInfo.meeting.latestArrival.date
                        ).format("ddd, MMM D")}
                       </span>`;
        }
      }

      if (type == "return") {
        // label += '<strong>Return: </strong> ';
        if (this.meetingInfo.meeting.earliestDeparture.time !== null) {
          label += `<span class="is-size-7">DEPART no earlier than
                        <b>${this.$date.convertTime(
                          this.meetingInfo.meeting.earliestDeparture.time
                        )}</b>
                        on ${moment(
                          this.meetingInfo.meeting.earliestDeparture.date
                        ).format("ddd, MMM D")}
                       </span>`;
        }
      }

      return label;
    },
    validateMeetingDates(date, type) {
      // console.log(`validateMeetingDates() ${JSON.stringify(date)} - ${type}`);
      // check date to see if we should how/hide Time Selector and Adv SO
      // check if the date is restricted by Meeting Admin
      if (type === "depart") {
        let dDate = moment(this.meetingsDepartDate.date).format("YYYY-MM-DD");
        if (dDate == this.meetingInfo.meeting.latestArrival.date) {
          this.showTimeSelectorDepart = false;
          this.showAdvancedSearchD = false;
        } else {
          this.showTimeSelectorDepart = true;
          this.showAdvancedSearchD = true;
        }
      }

      if (type === "return") {
        let rDate = moment(this.meetingsReturnDate.date).format("YYYY-MM-DD");
        if (rDate == this.meetingInfo.meeting.earliestDeparture.date) {
          this.showTimeSelectorReturn = false;
          this.showAdvancedSearchR = false;
        } else {
          this.showTimeSelectorReturn = true;
          this.showAdvancedSearchR = true;
        }
      }
    },

    // for multi-city
    focusNextLeg(val) {
      /*
      var index = val[0];
      var info = val[1];
      if (this.multiCityRows.length > index + 1) {
        var ref = this.$refs[`multi${this.multiCityRows[index + 1].id}`];
        ref[0].toggleActive(info);
      }
      */
    },
    //autofill the depart date
    toggleDepart() {
      if (this.startDate.date == null) {
        //pre-set depart date value
        this.startDate.date = new Date();
      }

      //this.$refs.departDate.toggle();
    },
    //toggle the returnDate datePicker dropdown open
    toggleReturn(value) {
      if (this.tripVal === this.TRIP_ROUNDTRIP) {
        if (this.endDate.date == null) {
          //pre-set return date value
          this.endDate.date = value;
        }
        this.$refs.returnDate.toggle();
      }
    },

    defaultDateRow(index) {

      if (index > 0) {
        let minDay = new Date(this.multiCityRows[index - 1].depDate.date);
        //nextDay.setDate(nextDay.getDate() + 1);
        return minDay;
      } else {
        return this.today;
      }
    },
    //add a multiCity row
    addRow() {
      let row = {
        fromLoc: "",
        toLoc: "",
        depDate: {
          date: null,
          advanced: {
            time: null,
            tod: "Anytime",
          },
        },
      };
      this.multiCityRows.push(row);
    },
    //delete a multiCity row
    removeRow(index) {
      this.multiCityRows.splice(index, 1);
      //this.$store.dispatch("bookTravel/removeMulti", index);
    },
    //update a multiCity row
    updateRow(index, newChild) {
      //this.$store.dispatch("bookTravel/updateMulti", [index, newChild]);
      this.$set(this.multiCityRows, index, newChild);
    },
    setDefaultFormValues() {
      //Use booked hotel details to set default form values
      if (this.flightArrivalMoment.isValid()) {
        this.checkinDate = this.flightArrivalDate;
      }

      if (this.flightDepartureMoment.isValid()) {
        this.checkoutDate = this.flightDepartureDate;
      }

      if (this.flightArrivalLeg?.arrivingAirport) {
        this.location = this.$helpers.findAirportByCode(
          this.flightArrivalLeg.arrivingAirport
        );
      }
    },
  },
  created() {
    this.TRIP_ONE_WAY = 0;
    this.TRIP_ROUNDTRIP = 1;
    this.TRIP_MULTI_CITY = 2;
  },
  mounted() {
    //intialize two multi-city rows
    this.addRow();
    this.addRow();

    // TODO Test meeting
    if (this.pathMixin_isMeeting) {
      this.setTravellers();
    }

    this.appendCustomHeader("flight");
  },
};
</script>

<style lang="scss" scoped>
.fade {
  opacity: 0.3;
  transition: opacity 0.05s ease-in-out;
  -moz-transition: opacity 0.05s ease-in-out;
  -webkit-transition: opacity 0.05s ease-in-out;
}
.fade:hover {
  opacity: 0.7;
}
</style>
